import { IInputTypes } from "./InputTypes"

import {
  FormLabel,
  Input as ChakraInput,
  InputGroup,
  InputRightElement,
  Text,
} from "@chakra-ui/react"
import Button from "components/UI/atoms/Button"
import Icon from "components/UI/atoms/Icon"

const Input: React.FC<IInputTypes> = ({
  id,
  name,
  type,
  value,
  placeholder,
  onChange,
  onBlur,
  error,
  errorMessage,
  label,
  autoFocus = false,
  styles,
  withButton,
  buttonProps,
  variant,
  size,
  icon,
  readonly,
  iconMargin,
  onKeyPress,
  height,
  borderLeft,
  borderLeftRadius,
  style,
  stylePlaceholder
}) => {

  const isError = error && errorMessage

  return (
    <>
      {label && (
        <FormLabel htmlFor={name} pointerEvents="none" fontSize="base" color={`${isError ? "error" : "main_text_color"}`}>
          {label}
        </FormLabel>
      )}
      <InputGroup width={styles?.width} height={styles?.height}>
        <ChakraInput
          borderLeft={borderLeft}
          borderLeftRadius={borderLeftRadius}
          height={height}
          id={id}
          name={name}
          type={type}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          autoFocus={autoFocus}
          variant={error ? "error" : variant}
          size={size}
          placeholder={placeholder}
          onKeyPress={onKeyPress}
          readOnly={readonly}
          style={style}
          _placeholder={stylePlaceholder}
          {...styles}
        />
        {withButton && buttonProps && (
          <InputRightElement
            height="100%"
            width={155}
            justifyContent="flex-end"
          >
            <Button
              type={buttonProps.type}
              text={buttonProps.text}
              onClick={buttonProps.onClick}
              isDisabled={buttonProps.isDisabled}
              isLoading={buttonProps.isLoading}
              styles={buttonProps.styles}
            />
          </InputRightElement>
        )}
        {icon && (
          <InputRightElement
            height="100%"
            justifyContent="flex-end"
            margin={iconMargin}
          >
            <Icon name={icon} iconStyles={{ fill: "#00000" }} />
          </InputRightElement>
        )}
      </InputGroup>
      {error && errorMessage && (
        <Text color="error" fontSize="base">
          {errorMessage}
        </Text>
      )}
    </>
  )
}
export default Input
